import  { useState, useEffect } from "react";
import useVendorStore from "../../AuthStore/store/authStore";
import { getPolicyFromData } from "../../Services/vendorFromServices";

const SubmittedFromsVendor = () => {
  const { authToken } = useVendorStore();
   const {getvendorId}=useVendorStore();
  const [policyFromData, setPolicyFromData] = useState([]);

  useEffect(() => {
    const fetchingPolicyData = async () => {
      try {
       console.log("Policy alling ...")
        const res = await getPolicyFromData(authToken,getvendorId);
        setPolicyFromData(res.data || []);
      } catch (error) {
        console.error("Error fetching policy data in dashboard", error);
      }
    };

    fetchingPolicyData();
  }, [authToken,getvendorId]);

  console.log("PolicyFromData", policyFromData);

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg lg:col-span-2">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          Submitted Forms
        </h3>
      </div>
      <div className="border-t border-gray-200 px-4 py-5 sm:p-6 overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Form ID
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Customer
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Policy Name
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Type
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Amount
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Submitted On
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {policyFromData.length > 0 ? (
              policyFromData.map((form) => (
                <tr key={form.id}>
                  <td className="px-4 py-3 text-sm text-gray-900">{form.id}</td>
                  <td className="px-4 py-3 text-sm text-gray-900">
                    {form.name}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900">
                    {form.policy_name}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900">
                    {form.type}
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <span
                      className={`inline-flex px-2 text-xs leading-5 font-semibold rounded-full ${
                        form.status === "approved"
                          ? "bg-green-100 text-green-800"
                          : form.status === "pending"
                          ? "bg-yellow-100 text-yellow-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {form.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900">
                    ₹{form.amount}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {form.date_of_birth}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="7"
                  className="px-4 py-6 text-center text-gray-500 text-sm"
                >
                  No forms submitted yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubmittedFromsVendor;
